import { render, staticRenderFns } from "./doubleStubMatch.vue?vue&type=template&id=b5c32b14&scoped=true&"
import script from "./doubleStubMatch.vue?vue&type=script&lang=js&"
export * from "./doubleStubMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c32b14",
  null
  
)

export default component.exports